import { fetchGetServiceSuccess, fetchGetServiceFailure } from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { GET_SERVICE } from '../../constants/constants';
import moment from "moment";

export const getServiceByCode = (setLoading, serviceCode, serviceOptions, setState, isEdit, setAddserviceuse, setFormInitialValues) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await determineBaseUrlAndPerformApiCall(`${GET_SERVICE}/${serviceCode}`, 'GET');
      setLoading(false);
      setAddserviceuse(response);
  
      let updatedValues = {
        name: response?.name || '',
        code: response?.serviceCode || '',
        description: response?.description || '',
        startsOn: isEdit ? moment(response?.Validity?.from) : moment(),
        endson: moment(response?.Validity?.to).utc(),
        isBundle: response?.isBundle || false,
        attributeList: [],
        services: [],
        eventConfigurations: [],
      };
  
      if (response?.isBundle) {
        setState(true);
        updatedValues.services = response?.bundledServices?.map(value => ({ label: value, value }));
      } else {
        setState(false);
      }
  
      if (response?.provisioningAttributes) {
        response?.provisioningAttributes.forEach((resp) => {
          updatedValues.attributeList.push({
            type: { label: "Provisional Attributes", value: "Provisional Attributes" },
            name: { label: resp?.name, value: resp?.name },
            value: resp?.default,
          });
        });
      }
  
      if (response?.usageAttributes) {
        const usageArray = response?.usageAttributes?.map(value => ({
          label: value,
          value: value
        }));
        updatedValues.attributeList.push({
          type: { label: "Usage Attributes", value: "Usage Attributes" },
          name: usageArray,
        });
      }
  
      if (serviceOptions) {
        const configuration = serviceOptions?.find(attr => attr.name === "eventConfigurations")?.options;
        if (configuration) {
          const valueMap = new Map(configuration.map(option => [option.value, option]));
          const eventToValueMap = new Map(
            configuration.map(option => [`events.${option.value.replace(/ /g, '')}`, option.value])
          );
  
          const result = (response?.eventConfigurations || [])
            .map(event => eventToValueMap.get(event))
            .filter(eventValue => eventValue && valueMap.has(eventValue))
            .map(eventValue => valueMap.get(eventValue));
  
          updatedValues.eventConfigurations = result;
        }
      }
  
      setFormInitialValues(updatedValues);
      dispatch(fetchGetServiceSuccess(response));
    } catch (errorResp) {
      setLoading(false);
      dispatch(fetchGetServiceFailure(errorResp.message));
    }
  };
  
